export const ledgerRecord = {
  observedAt: "2026-07-12 04:56 CST",
  runtime: "Hyperledger Fabric v3.1.4",
  channel: "evidencechannel",
  chaincode: "moonevidence 1.0",
  organizations: ["Org1MSP", "Org2MSP"],
  artifactName: "starlittle-MoonEvidence-0.5.1.zip",
  artifactSha256: "ab0dd9b6fcd30ce5ee3fc42a4105dd5e5dc4c245ab69e4c60a41a731897b5bd3",
  digest: "sha256:564b79c16878c4fac3d50e5b8b61ac4b82207aa01a45b02fb97210a049a53a0d",
  transactionId: "f004f179600854ee3faea0e2706c08cf938073d969ccd6434fcca3be48965c2d",
  block: "16",
  validation: "VALID",
  duplicateBlock: "17",
  channelHeight: "18",
  paths: {
    record: "https://github.com/wenlittle/MoonEvidence/tree/main/docs/records/fabric-e2e/2026-07-12-v0.5.1",
    transactions: "https://github.com/wenlittle/MoonEvidence/blob/main/docs/records/fabric-e2e/2026-07-12-v0.5.1/transactions.json",
    verification: "https://github.com/wenlittle/MoonEvidence/blob/main/docs/records/fabric-e2e/2026-07-12-v0.5.1/verification.json",
    guide: "https://github.com/wenlittle/MoonEvidence/tree/main/integrations/fabric",
  },
} as const;
